import { createFileRoute, Link } from '@tanstack/react-router'
import { z } from 'zod'
import { Button } from '@/components/ui/button'
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card'

const errorSearchSchema = z.object({
  error: z.string().optional(),
})

export const Route = createFileRoute('/auth/error')({
  validateSearch: errorSearchSchema,
  component: AuthErrorRoute,
})

function AuthErrorRoute() {
  const { error } = Route.useSearch()

  const getErrorMessage = (error?: string) => {
    switch (error) {
      case 'Configuration':
        return 'There is a problem with the server configuration.'
      case 'AccessDenied':
        return 'You do not have permission to sign in.'
      case 'Verification':
        return 'The verification link has expired or has already been used.'
      case 'OAuthAccountNotLinked':
        return 'This email is already associated with another account.'
      case 'OAuthCallback':
        return 'There was a problem with the authentication callback.'
      case 'OAuthCreateAccount':
        return 'Could not create an account with this provider.'
      case 'OAuthSignin':
        return 'Error in the OAuth sign-in process.'
      case 'SessionRequired':
        return 'Please sign in to access this page.'
      default:
        return 'An unexpected error occurred during authentication.'
    }
  }

  return (
    <div className="flex min-h-screen items-center justify-center bg-background">
      <Card className="w-full max-w-md">
        <CardHeader className="text-center">
          <CardTitle className="text-2xl font-bold text-destructive">
            Authentication Error
          </CardTitle>
          <CardDescription>
            {getErrorMessage(error)}
          </CardDescription>
        </CardHeader>
        <CardContent className="space-y-4">
          <div className="flex flex-col gap-2">
            <Button asChild>
              <Link to="/auth/signin">Try Again</Link>
            </Button>
            <Button variant="outline" asChild>
              <Link to="/">Go Home</Link>
            </Button>
          </div>
        </CardContent>
      </Card>
    </div>
  )
}
